import { defineProfile } from "./define.js";

export const GENERAL_PROFILE = defineProfile("general", {
  labels: [],
  home: ["unread_chats", "ai_handoffs", "orders_today", "bookings_today", "new_leads"],
  kpis: [
    "conversations",
    "response_time",
    "ai_resolution",
    "orders",
    "bookings",
    "leads",
    "ai_handoffs",
  ],
  panel: ["orders", "quotes", "appointments", "deal"],
  quickActions: ["send_product", "payment_link", "new_quote", "book_appointment"],
  contactFields: [],
  aiTools: ["search_kb", "escalate", "save_lead"],
  cloudStarterMenu: "general_menu",
});
